import { h, Component } from 'preact'
import linkRef from 'linkref'
import { connect } from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import CustomColorPicker from './CustomColorPicker'

import util from '../util'
import Renderer from '../canvas/renderer'

import designService from '../service/designService'
import Masonry from "react-masonry-component";
import constants from "../constants";
import $ from "jquery";
import designDomain from "../domain/designDomain";

export default @connect(reduce, actions)
class AsideBackgrounds extends Component {
    constructor() {
        super()

        this.state = {
            customColor: '',
            colors: [],
            ogColorData: ''
        }

        this.updateBackgroundColor = (colorData) => {
            Renderer.updatePageBackground(util.getPageInViewport($('.page')), colorData);
            this.setState({ ogColorData: colorData });
        }

        this.manualChangeCustomColor = (ev) => {
            const color = ev.target.value
            this.setState({ 'customColor': color })
            this.updateBackgroundColor('#' + color)
        }

        this.saveCustomColor = () => {
            if (!this.state.customColor) return

            const color = '#' + this.state.customColor
            let colors = this.props.designColors
            if (colors.indexOf(color) === -1) {
                colors = [...colors, color]
                designService.updateDesignColors({
                    id: this.props.designId,
                    colors: colors.join(',')
                })

                this.props.updateDesignColors(colors)
            }
        }

        this.handleChange = (colorData) => {
            this.updateBackgroundColor(colorData);
        }

        this.getColorData = () => {
            const $element = this.props.$element || util.getPageInViewport($('.page'));
            if ($element.attr('data-color')) {
                return JSON.parse($element.attr('data-color'));
            } else {
                return {mode: 'solid', colors: [$element.css('background-color'), '#fff']};
            }
        }
    }

    componentDidMount() {
        //this.initializePicker()
    }

    initializePicker() {
        const picker = ColorPicker(this.refs['aside-bg-picker'], (hex, hsv, rgb) => {
            this.updateBackgroundColor(hex)
            this.setState({ 'customColor': hex.slice(1) })
        })
    }
    
    openEyedropper() {
        if (!window.EyeDropper) {
            console.log('Your browser does not support the EyeDropper API');
            return;
        }

        const eyeDropper = new EyeDropper();

        eyeDropper.open().then(result => {
            console.log("result eyedroper ", result);
            this.setState({ 'customColor': result.sRGBHex });
            this.updateBackgroundColor(result.sRGBHex);
        }).catch(e => {
            console.log("eyedropper error ", e);
        });
    }

    render(props, state) {
        const designColors = props.designColors.map((color) =>
            <li onClick={() => this.updateBackgroundColor(color)} style={'background: ' + color} />
        )

        const brandColorsTitle = props.brand.colors && props.brand.colors.length > 0 ? <h6 className="title-colors">Brand Colors</h6> : ''
        const brandColors = props.brand.colors && props.brand.colors.length > 0 ? props.brand.colors.map((customColor) =>
            <li onClick={() => this.updateBackgroundColor(customColor.colorCode)} style={'background: ' + customColor.colorCode} />
        ) : ''

        return (
            <div id="app-aside-background" class="aside-text">
                <div class="to-root">
                    <a onClick={ () => props.goToRoot() }>
                        All graphics
                    </a>
                    <span class="path">&gt;&nbsp; Backgrounds</span>
                </div>
                
                <CustomColorPicker
                    pickerType={ 'gradient' }
                    ogColorData={ this.getColorData() }
                    handleChange={ this.handleChange }/>
                
            </div>
        )
    }
}
